import { useTranslationExports } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TaskStatus } from '@dealstack/shared/lib/generated';
import { StatusBadge } from '@dealstack/frontend/shared/components/StatusBadge/StatusBadge.tsx';

export const TaskStatusBadge = ({ status }: { status: TaskStatus }) => {
	const tExports = useTranslationExports();

	const defaultValue = {
		text: tExports('table.task_status.awaiting_compilation'),
		color: 'orange.8',
	};

	const mappedValue: Record<string, typeof defaultValue> = {
		[TaskStatus.DONE]: {
			text: tExports('table.task_status.ready_for_download'),
			color: 'teal.8',
		},
		[TaskStatus.IN_PROGRESS]: defaultValue,
		[TaskStatus.ERROR]: {
			text: tExports('table.task_status.error'),
			color: 'red.8',
		},
		[TaskStatus.PENDING]: defaultValue,
	};

	const item = mappedValue[status] ?? defaultValue;

	return <StatusBadge text={item.text} textColor={item.color} color={item.color} />;
};
